<template>
  <div class="render">
    <div class="top">
      <h1>Скрипты звонков</h1>
      <div class="script-actions">
        <ImportScripts :callback_refresh="renderData" />

        <CreateScript
          :show_dialog="popup"
          :callback_refresh="renderData"
          :data="scenario.data"
          :id="scenario.id"
          :scenario_name="scenario.data.name"
        />
      </div>
    </div>
    <div class="content_table">
      <FilterMy
        :visible="{ date: true, scripts: data, callsMultiple: true }"
        :dateOnly="true"
        :showExport="false"
        @updateFilter="onUpdateFilter"
      />
      <Table
        @copy="copyScenario"
        @delete="deleteScenario"
        @draw="drawScenario"
        @edit="editScenarioEmit"
        @export="exportScenario"
        :callback_export="exportSelectedScripts"
        :page_type="'scripts'"
        :callback_edit="editScenario"
        :callback_delete="deleteScenario"
        :items="action_items"
        :callback_draw="drawScenario"
        :callback_refresh="renderData"
        :data="filteredData"
        :loading="loading"
        :headers="headers"
      />
    </div>
    <div v-if="im_tester">
      <DeleteScenarium base_name="Тестовая пользовательская база номеров" />
      <TestCall />
    </div>
    <ScenarioDraw
      :lib="lib"
      :callback_refresh="renderData"
      :show_dialog="edit_scenario"
      :id="scenario.id"
      :data="scenario.data"
      :close="closeScenario"
    />
  </div>
</template>
<script>
import FilterMy from '../components/FilterMy.vue';
import Table from '../components/Table/DataTable.vue';
import CreateScript from '../components/Modal/Scenaries/CreateScript.vue';
import ScenarioDraw from '../components/Modal/Scenaries/ScenarioDraw.vue';
import DeleteScenarium from '../components/Modal/Scenaries/DeleteScenarium.vue';
import TestCall from '../components/Modal/Scenaries/TestCall.vue';
import ImportScripts from '../components/Modal/Scenaries/ImportScipts.vue';

export default {
  components: {
    Table,
    CreateScript,
    DeleteScenarium,
    TestCall,
    ScenarioDraw,
    FilterMy,
    ImportScripts,
  },
  beforeMount() {
    this.$http.post('/script/lib', {}, (data) => {
      this.lib = data;
    });
    this.renderData();
  },
  methods: {
    editScenarioEmit(item) {
      this.editScenario(true, { id: item.guid, item: item });
    },
    editScenario(popup, item) {
      // где-то тут начитается присвоение даты
      this.scenario.id = item.id;
      this.scenario.data = item.item;
      this.popup = popup;
    },
    deleteScenario(item) {
      let guid = item.guid;
      this.$http.post(
        '/script/delete',
        {
          id: guid,
        },
        () => {
          this.renderData();
        },
      );
    },
    copyScenario(item) {
      let guid = item.guid;
      this.$http.post(
        '/script/copy',
        {
          id: guid,
        },
        () => {
          this.renderData();
        },
      );
    },
    downloadScenario(item) {
      if (!item || !item.data) {
        console.error('У скрипта отсутствует data:', item);
        return;
      }

      const content =
        typeof item.data === 'string' ? item.data : JSON.stringify(item.data);

      const safeName = String(item.name || 'script')
        .replace(/[\\/:*?"<>|]/g, '_')
        .trim();

      const blob = new Blob([content], {
        type: 'application/json;charset=utf-8',
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = `${safeName || 'script'}.json`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    },

    exportScenario(item) {
      this.downloadScenario(item);
    },

    exportSelectedScripts(selected) {
      selected.forEach((item, index) => {
        setTimeout(() => {
          this.downloadScenario(item);
        }, index * 200);
      });
    },
    drawScenario(item) {
      let guid = item.guid;
      if (guid && item) {
        this.scenario.id = guid;
        this.scenario.data = item;
        this.edit_scenario = true;
      }
    },
    closeScenario() {
      this.scenario.id = false;
      this.edit_scenario = false;
    },
    onUpdateFilter(filters) {
      this.filters = filters;
    },
    renderData(render = true) {
      this.scenario = { id: false, data: { name: '' } };
      this.popup = false;
      if (render == true) {
        this.loading = true;
        this.$http.post('/script/list', {}, (data) => {
          this.loading = false;
          this.data = data;
        });
      }
    },
  },
  computed: {
    filteredData() {
      const toIsoDate = (value) => {
        if (!value) return '';
        const [day, month, year] = value.split('.');
        return `${year}-${month}-${day}`;
      };

      let rows = this.data;

      if (Array.isArray(this.filters.script) && this.filters.script.length) {
        rows = rows.filter((item) => this.filters.script.includes(item.guid));
      } else if (this.filters.script) {
        rows = rows.filter((item) => item.guid === this.filters.script);
      }
      if (Array.isArray(this.filters.date) && this.filters.date.length === 2) {
        const [from, to] = this.filters.date;
        rows = rows.filter((item) => {
          const itemDate = toIsoDate(item.created_at);
          return itemDate >= from && itemDate <= to;
        });
      }

      return rows;
    },
  },
  data() {
    return {
      filters: {},
      edit_scenario: false,
      popup: false,
      loading: true,
      lib: [],
      scenario: {
        id: 0,
        data: {},
      },
      im_tester: false,
      data: [],
      action_items: [
        { title: 'Изменить', action: 'draw' },
        { title: 'Переименовать', action: 'edit' },
        { title: 'Копировать', action: 'copy' },
        { title: 'Экспортировать', action: 'export' },
        { title: 'Удалить', action: 'delete' },
      ],
      headers: [
        { text: '№', align: 'start', value: 'id' },
        { text: 'Название', value: 'name' },
        { text: 'Дата создания', value: 'created_at' },
        { text: 'Действия', value: 'actions', sortable: false },
      ],
    };
  },
};
</script>
<style scoped>
.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
@media (max-width: 650px) {
  .top {
    flex-direction: column;
  }
  h1 {
    margin-bottom: 20px;
  }
}
@media (max-width: 400px) {
  h1 {
    margin-top: 15px;
  }
}
.script-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>
